module.exports = __webpack_public_path__ + "img/tiff.6c18c22b.svg";